import { fold } from '@blpde/nx-ui';

/**
 * The fold of the dictionary's „same word“ checks: the search's own fold
 * (`@blpde/nx-ui`'s `fold`, which the Go side mirrors as `textquery.Fold`), so
 * „Torblatt“, „torblatt“ and „TORBLATT“ — „Müller“ and „mueller“ — are one
 * word here exactly as they are for the search and for master's validator.
 */
export function dictionaryFold(word: string): string {
  return fold(word).text;
}
